import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { isNil } from '@web/utils';
import { AdminBrandBannerStatus } from '@web/shared/module/brand';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandBannerStatusProviderService {
  private readonly entries = new Map<AdminBrandBannerStatus, string>([
    [AdminBrandBannerStatus.Active, 'Aktywny'],
    [AdminBrandBannerStatus.Inactive, 'Nieaktywny'],
  ]);

  public labelFor(status: AdminBrandBannerStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBrandBannerStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
